import { render, staticRenderFns } from "./Userprofile.vue?vue&type=template&id=1c3e0d5e&"
import script from "./Userprofile.vue?vue&type=script&lang=js&"
export * from "./Userprofile.vue?vue&type=script&lang=js&"
import style0 from "./Userprofile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports